import React from 'react';
import CarCard from './CarCard';

const CarGrid = ({ cars, onOpenApplicationModal, onOpenDetailsModal }) => {
    // Проверяем, есть ли автомобили для отображения
    if (!cars || cars.length === 0) {
        return (
            <div className="no-results">
                <h3>Автомобили не найдены</h3>
                <p>Попробуйте изменить параметры поиска или фильтрации</p>
            </div>
        );
    }

    return (
        <div className="car-grid">
            {cars.map(car => (
                <CarCard
                    key={car.id}
                    car={car}
                    onOpenApplicationModal={(selectedCar) => onOpenApplicationModal(selectedCar)}
                    onOpenDetailsModal={onOpenDetailsModal}
                />
            ))}
        </div>
    );
};

export default CarGrid;